"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKpiAlertTranslationData = exports.translateDateFilter = void 0;
var tslib_1 = require("tslib");
var lowerFirst_1 = tslib_1.__importDefault(require("lodash/lowerFirst"));
var sdk_ui_filters_1 = require("@gooddata/sdk-ui-filters");
var sdk_model_1 = require("@gooddata/sdk-model");
function filterMetadata(filter) {
    var _a, _b, _c, _d, _e, _f;
    if (sdk_model_1.isRelativeDateFilter(filter)) {
        return tslib_1.__assign(tslib_1.__assign({}, sdk_model_1.relativeDateFilterValues(filter)), { type: "relative" });
    }
    else if (sdk_model_1.isAbsoluteDateFilter(filter)) {
        return tslib_1.__assign(tslib_1.__assign({}, sdk_model_1.absoluteDateFilterValues(filter)), { type: "absolute" });
    }
    else if (filter.dateFilter.type === "relative") {
        return {
            type: "relative",
            from: Number.parseInt((_b = (_a = filter.dateFilter.from) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "0", 10),
            to: Number.parseInt((_d = (_c = filter.dateFilter.to) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "0", 10),
            granularity: filter.dateFilter.granularity,
        };
    }
    else {
        return {
            type: "absolute",
            from: (_e = filter.dateFilter.from) === null || _e === void 0 ? void 0 : _e.toString(),
            to: (_f = filter.dateFilter.to) === null || _f === void 0 ? void 0 : _f.toString(),
        };
    }
}
function translateDateFilter(filter, intl, dateFormat) {
    var metadata = filterMetadata(filter);
    return metadata.type === "absolute"
        ? sdk_ui_filters_1.DateFilterHelpers.formatAbsoluteDateRange(metadata.from, metadata.to, dateFormat)
        : sdk_ui_filters_1.DateFilterHelpers.formatRelativeDateRange(metadata.from, metadata.to, metadata.granularity, intl);
}
exports.translateDateFilter = translateDateFilter;
function getIntlIdRoot(filter) {
    var metadata = filterMetadata(filter);
    if (metadata.type === "absolute") {
        return "filters.alertMessage.relativePreset.inPeriod";
    }
    var hasOneBoundToday = metadata.from === 0 || metadata.to === 0; // e.g. last 4 months, next 6 days
    var isLastOneX = metadata.from === -1 && metadata.to === -1; // e.g last month
    var isNextOneX = metadata.from === 1 && metadata.to === 1; // e.g. next month
    return hasOneBoundToday || isLastOneX || isNextOneX
        ? "filters.alertMessage.relativePreset"
        : "filters.alertMessage.relativePreset.inPeriod";
}
function getKpiAlertTranslationData(filter, intl, dateFormat) {
    if (!filter || sdk_model_1.isAllTimeDateFilter(filter)) {
        return null;
    }
    return {
        intlIdRoot: getIntlIdRoot(filter),
        rangeText: lowerFirst_1.default(translateDateFilter(filter, intl, dateFormat)),
    };
}
exports.getKpiAlertTranslationData = getKpiAlertTranslationData;
//# sourceMappingURL=translationUtils.js.map